import { render, staticRenderFns } from "./DoubaoAccountList.vue?vue&type=template&id=52c3d148"
import script from "./DoubaoAccountList.vue?vue&type=script&lang=js"
export * from "./DoubaoAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports